import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home, Search, Store } from 'lucide-react';
import turnlinkimg from '../../assets/turnlink.png';
import './NotFound.css';

/**
 * 404 con dos contextos:
 *  - reason="page": la ruta no existe (dominio raíz).
 *  - reason="business": el slug no corresponde a ningún negocio (subdominio o /slug).
 * Cada uno responde "¿dónde estoy?" y ofrece la salida más probable; el segundo
 * además invita a registrar el negocio (es donde llega alguien que teclea mal su
 * URL o un negocio que ya se dio de baja).
 */
const ROOT = `https://${process.env.REACT_APP_ROOT_DOMAIN || 'turnlink.app'}`;

const NotFound = ({ reason = 'page', slug }) => {
  useEffect(() => {
    document.getElementById('initial-loader')?.remove();
    document.body.classList.add('js-loaded');
    document.title = reason === 'business' ? 'Negocio no encontrado · Turnlink' : 'Página no encontrada · Turnlink';
  }, [reason]);

  const isBusiness = reason === 'business';
  const onRootDomain = window.location.hostname.endsWith(process.env.REACT_APP_ROOT_DOMAIN || 'turnlink.app');

  return (
    <main className="nf-root">
      <div className="nf-card">
        <img src={turnlinkimg} alt="Turnlink" className="nf-logo" />
        <div className="nf-code" aria-hidden="true">404</div>
        <h1 className="nf-title">{isBusiness ? 'Este negocio no está en Turnlink' : 'Esta página no existe'}</h1>
        <p className="nf-text">
          {isBusiness ? (
            <>No encontramos ningún negocio en <code className="nf-slug">{slug || window.location.hostname}</code>. Revisa que el link esté bien escrito o pídeselo de nuevo al negocio.</>
          ) : (
            <>El link puede estar mal escrito o la página se movió.</>
          )}
        </p>

        <div className="nf-actions">
          {isBusiness ? (
            <>
              <a className="nf-btn nf-btn-primary" href={onRootDomain ? ROOT : '/'}>
                <Home size={16} /> Ir a Turnlink
              </a>
              <a className="nf-btn" href={onRootDomain ? `${ROOT}/registro` : '/registro'}>
                <Store size={16} /> ¿Es tu negocio? Regístralo
              </a>
            </>
          ) : (
            <>
              <Link className="nf-btn nf-btn-primary" to="/">
                <Home size={16} /> Ir al inicio
              </Link>
              <button type="button" className="nf-btn" onClick={() => window.history.back()}>
                <ArrowLeft size={16} /> Regresar
              </button>
            </>
          )}
        </div>

        {!isBusiness && (
          <p className="nf-hint"><Search size={13} /> Si buscas la agenda de un negocio, el link es <code className="nf-slug">nombre.turnlink.app</code>.</p>
        )}
      </div>
    </main>
  );
};

export default NotFound;
